import { useState, type FormEvent } from "react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useChangePortalUserPassword } from "@/api/mutations/portalUsers";

// Passwort eines Portal-Admins aendern (min. 12, Server validiert).
export function ChangePasswordDialog({
  open,
  onOpenChange,
  userId,
  userEmail,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  userId: string;
  userEmail: string;
}) {
  const [password, setPassword] = useState("");
  const change = useChangePortalUserPassword();

  function submit(e: FormEvent) {
    e.preventDefault();
    change.mutate(
      { id: userId, password },
      {
        onSuccess: () => {
          setPassword("");
          onOpenChange(false);
          toast.success("Passwort geaendert");
        },
      },
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle>Passwort aendern</DialogTitle>
          <DialogDescription>{userEmail} — mindestens 12 Zeichen.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="cp-pass">Neues Passwort</Label>
            <Input id="cp-pass" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="change-password-input" />
          </div>
          {change.isError && (
            <div className="text-sm text-danger" data-testid="change-password-error">
              {change.error.message}
            </div>
          )}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={change.isPending}>
              Abbrechen
            </Button>
            <Button type="submit" disabled={change.isPending} data-testid="change-password-submit">
              {change.isPending ? "…" : "Aendern"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
